// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RV8OrC {
  background: var(--inline-error-background);
  border: 1px solid var(--status-error);
  border-radius: var(--radius-s);
  color: var(--text-neutral-dark);
  font-size: var(--font-size-md);

  display: flex;
  align-items: flex-start;
  gap: var(--spacing-1);

  padding-top: var(--spacing-1);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  padding-right: var(--spacing-1-5);

  box-sizing: border-box;
}
.StXgGe {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
.d7uaO4 {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
.dtvUdO {
  flex: 1;
  word-break: break-word;
  margin-top: 0;
  margin-bottom: 0;
  line-height: 1.4;
}
.z0uovG {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/InlineError/InlineError.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;;EAE9B,aAAa;EACb,uBAAuB;EACvB,qBAAqB;;EAErB,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;;EAEjC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,OAAO;EACP,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB","sourcesContent":[".loginInlineError {\n  background: var(--inline-error-background);\n  border: 1px solid var(--status-error);\n  border-radius: var(--radius-s);\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-md);\n\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-1);\n\n  padding-top: var(--spacing-1);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  padding-right: var(--spacing-1-5);\n\n  box-sizing: border-box;\n}\n.loginInlineErrorIcon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n}\n.loginInlineErrorIconButton {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n}\n.loginInlineErrorText {\n  flex: 1;\n  word-break: break-word;\n  margin-top: 0;\n  margin-bottom: 0;\n  line-height: 1.4;\n}\n.loginInlineErrorClose {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginInlineError": `RV8OrC`,
	"loginInlineErrorIcon": `StXgGe`,
	"loginInlineErrorIconButton": `d7uaO4`,
	"loginInlineErrorText": `dtvUdO`,
	"loginInlineErrorClose": `z0uovG`
};
module.exports = ___CSS_LOADER_EXPORT___;
